export default "/img/MY.a906005fe64d33d2fa5125bc77ea5c40.png";